// routes/ManagerRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import ManagerDashboardPage from "../pages/ManagerPortalPages/ManagerDashboardPage";
import AddLearningPathPage from "../pages/ManagerPortalPages/AddLearningPathPage";
import ManagerAssessmentQuizResultsPage from "../pages/ManagerPortalPages/ManagerQuizResults";
import LearningPathDetails from "../pages/LearningPathDetails";
import { BulkInsertLearningPathsPage } from "../pages/ManagerPortalPages/BulkInsertLearningPathsPage";
import { UserGroupsPage } from "../pages/ManagerPortalPages/UsersAndGroups";
import { GroupUsersPage } from "../pages/ManagerPortalPages/UserGroups";
import { ManagersAssessment } from "../pages/ManagerPortalPages/ManagerAssessment";
import AddProficiency from "../pages/Profile/AddProficiency";
import { SelectUsersGroups } from "../pages/ManagerPortalPages/UsersForAssessment";
import AddProficiencyManager from "../pages/ManagerPortalPages/AddProficiencyManager";
import { QuizSettingsPageManager } from "../pages/ManagerPortalPages/QuizSettings";
// import QuizResultsPage from "../pages/QuizPages/QuizResults";
import { SequenceProvider } from "../components/SequenceProvider";
import ProtectedRoute from "../components/ProtectedRoute";
import ManagerQuizResultsPage from "../pages/ManagerPortalPages/QuizResults";
import EditCreatedAssessment from "../pages/ManagerPortalPages/EditCreatedAssessment";
import EditUserAccess from "../pages/ManagerPortalPages/EditUserAccess";
import Contact from "../pages/contact"
import ManagerAssessmentArchive from "../pages/ManagerPortalPages/ManagerAssessmentArchive";
import ProtectedRouteWithManagerCheck from "./utils/ProtectedRouteWithManagerCheck";

const ManagerRoutes = (
  <>
    <Route
      path="/manager/contact"
      element={<Contact />}
    />
    <Route
      path="/manager/assessment-quiz-result/:user_id/:assessment_id"
      element={<ManagerQuizResultsPage />}
    ></Route>
    <Route
      path="/manager/assessment/view-recommendations/:assessment_id"
      element={<ManagerAssessmentQuizResultsPage />}
    />
    <Route
      path="/manager/add-learning-path"
      element={<AddLearningPathPage />}
    />
    <Route path="/learning-path/:id" element={<LearningPathDetails />} />
    <Route
      path="/manager/bulk-add-learning-path"
      element={<BulkInsertLearningPathsPage />}
    />
    <Route
      path="/manager/modify-assessment/:manager_id/:assessment_id"
      element={<ProtectedRouteWithManagerCheck><EditCreatedAssessment /></ProtectedRouteWithManagerCheck>}
    />
    <Route
      path="/manager/user-access/:manager_id/:assessment_id"
      element={<ProtectedRouteWithManagerCheck><EditUserAccess /></ProtectedRouteWithManagerCheck>}
    />
    <Route
      path="/:manager_id/manager/dashboard"
      element={
        <ProtectedRouteWithManagerCheck>
          <ManagerDashboardPage />
        </ProtectedRouteWithManagerCheck>
      }
    />
    <Route
      path="/:manager_id/manager/users-groups"
      element={<ProtectedRouteWithManagerCheck><UserGroupsPage /></ProtectedRouteWithManagerCheck>}
    />
    <Route path="/manager/users/:group_id" element={<GroupUsersPage />} />
    <Route
      path="/manager/assessment-archive/:manager_id"
      element={<ProtectedRouteWithManagerCheck><ManagerAssessmentArchive /></ProtectedRouteWithManagerCheck>}
    />
    <Route
      path="/:assessment_id/add-proficiency"
      element={<AddProficiency />}
    ></Route>
    <Route
      path="/:manager_id/manager/assessments"
      element={
        <SequenceProvider>
          <ProtectedRouteWithManagerCheck>
            <ManagersAssessment />
          </ProtectedRouteWithManagerCheck>
        </SequenceProvider>
      }
    />
    <Route
      path="/manager/:manager_id/:assessment_id/select-users"
      element={
        <SequenceProvider>
          <ProtectedRoute>
            <ProtectedRouteWithManagerCheck>
              <SelectUsersGroups />
            </ProtectedRouteWithManagerCheck>
          </ProtectedRoute>
        </SequenceProvider>
      }
    ></Route>
    <Route
      path="/manager/:manager_id/:assessment_id/add-proficiency"
      element={
        <SequenceProvider>
          <ProtectedRoute>
            <ProtectedRouteWithManagerCheck>
              <AddProficiencyManager />
            </ProtectedRouteWithManagerCheck>
          </ProtectedRoute>
        </SequenceProvider>
      }
    ></Route>
    <Route
      path="/manager/:assessment_id/quiz-settings"
      element={
        <SequenceProvider>
          <ProtectedRoute>
            <QuizSettingsPageManager />
          </ProtectedRoute>
        </SequenceProvider>
      }
    ></Route>
  </>
);

export default ManagerRoutes;
